import React, { createContext, useContext, useEffect, useState } from 'react';

const CompanyIdContext = createContext();

export const CompanyIdProvider = ({ children }) => {
  const [companyId, setCompanyId] = useState(() => {
    const storedCompanyId = localStorage.getItem('companyId');
    return storedCompanyId || ""; // Set to "" if not found in storage
  });

  useEffect(() => {
   //if (companyId) {
      localStorage.setItem('companyId', companyId);
   // }
  }, [companyId]);

  return (
    <CompanyIdContext.Provider value={{ companyId, setCompanyId }}>
      {children}
    </CompanyIdContext.Provider>
  );
};

export const useCompanyId = () => {
  return useContext(CompanyIdContext);
};
